<template lang="pug">
div
    // has more than 1 promotion per line item
    mixin discount(item, itemKey, discountLineItems)
        div(v-if="multipleDiscountLineItems")
            // will display if feature flag receipt capillary order level is false
            .row.grand-total-amount(v-if="itemAppliedDiscountPerLineItem(item).perLineItem")
                div(v-for="(discount, key) in itemAppliedDiscountPerLineItem(item).itemAppliedDiscounts")
                    .col-xs-11.p-l-sm
                        small._500 {{ discount.discount.name }}
                    .col-xs-1.p-r-sm(v-if="key === 0")
                        small.pull-right._500 x{{ discount.discount.quantity }}

            // cstore
            div(v-if="item.item_type === 'cstore'")
                .row
                    .col-xs-5
                        small {{ item.name }}
                    .col-xs-2
                        small.pull-right @{{ item.net_amount.toFixed(2) }}
                    .col-xs-2
                        small.pull-right x{{ item.quantity }}
                    .col-xs-3
                        small.pull-right {{ item.total_amount.toFixed(2) }}
                    div(v-if="discountTotal(item.applied_discounts) !== '0.00'")
                        .row
                            .col-xs-7
                                small.pull-right (Discount @{{ discountTotal(item.applied_discounts) }})
                        .row
                            .col-xs-7
                                small.pull-right (Normal Price: @{{ item.unit_price.toFixed(2) }})

            // fuel
            // only applicable for capillary usage
            // shell sg will always have capillary
            div(v-else)
                .row
                    .col-xs-5
                        small {{ item.name }} (Pump {{ item.fuel_details.pump_id }})
                    .col-xs-2
                        small.pull-right {{ item.unit_price.toFixed(3) }}
                    .col-xs-5
                        small.pull-right {{ item.amount.toFixed(2) }}
                .row
                    .col-xs-5
                        small {{ item.quantity.toFixed(3) }} litre
                    .col-xs-2
                        small.pull-right {{ getCurrency() }} / L

    // only has 1 promotion per line item
    mixin discountV2(discount)
        div(v-if="!multipleDiscountLineItems")
            .row.grand-total-amount(v-if="groupDiscountPerGroupItem(discount)")
                .col-xs-11.p-l-sm
                    small._500 {{ discount.discountName }}
                .col-xs-1.p-r-sm
                    small.pull-right._500 x{{ discount.discountQuantity }}

            div(v-for="lineItem in discount.groupLineItems")
                div(v-if="lineItem.itemType === 'cstore'")
                    .row
                        .col-xs-5
                            small {{ lineItem.productName }}
                        .col-xs-2
                            small.pull-right @{{ lineItem.totalAmount.toFixed(2) }}
                        .col-xs-2
                            small.pull-right x{{ lineItem.quantity }}
                        .col-xs-3
                            small.pull-right {{ lineItem.totalAmount.toFixed(2) }}
                    div(v-if="lineItem.totalDiscount !== 0")
                        .row
                            .col-xs-7
                                small.pull-right (Discount @{{ lineItem.totalDiscount.toFixed(2) }})
                        .row
                            .col-xs-7
                                small.pull-right (Normal Price: @{{ lineItem.unitPrice.toFixed(2) }})

                div(v-else)
                    .row
                        .col-xs-5
                            small {{ lineItem.productName }} (Pump {{ lineItem.fuelDetails.pump_id }})
                        .col-xs-2
                            small.pull-right {{ lineItem.unitPrice.toFixed(3) }}
                        .col-xs-5
                            small.pull-right {{ lineItem.amount.toFixed(2) }}
                    .row
                        .col-xs-5
                            small {{ lineItem.quantity.toFixed(3) }} litre
                        .col-xs-2
                            small.pull-right {{ getCurrency() }} / L

    mixin fuel(fuel)
        .row(v-if="fuel")
            .col-xs-5
                small {{ fuel.name }} (Pump {{ fuel.fuel_details.pump_id }})
            .col-xs-2
                small.pull-right {{ fuel.unit_price.toFixed(3) }}
            .col-xs-5
                small.pull-right {{ fuel.amount.toFixed(2) }}
        .row
            .col-xs-5
                small {{ fuel.quantity.toFixed(3) }} litre
            .col-xs-2
                small.pull-right {{ getCurrency() }} / L

    mixin product(product)
        .row(v-if="product")
            .col-xs-5
                small {{ product.name }}
            .col-xs-2
                small.pull-right @{{ product.unit_price.toFixed(2) }}&nbsp;
            .col-xs-2
                small.pull-right x{{ product.quantity }}
            .col-xs-3
                small.pull-right {{ product.amount.toFixed(2) }}

    .row(v-if="cancelProducts.length")
        .col-xs-12
            small.dark.block.text-center.m-b-sm Cancelled Items

            div(v-for="product in cancelProducts")
                +product(product)

    .row(v-if="discountLineItems.length || products.length || fuels.length")
        .col-xs-12
            div(v-if="isSale || isVoid")
                small.dark.block.text-center.m-y-sm Purchased Item(s)

            div(v-else-if="isRefund")
                small.dark.block.text-center.m-y-sm Refunded Item(s)

            div(v-for="fuel in fuels")
                +fuel(fuel)

            div(v-for="(item, itemKey) in discountLineItems" v-if="!isRefund")
                +discount(item, itemKey, discountLineItems)

            div(v-for="discount in groupDiscounts" v-if="!isRefund")
                +discountV2(discount)

            hr(v-if="discountLineItems.length && products.length")

            div(v-for="product in products")
                +product(product)

    .row
        .col-xs-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import StoreMixin from './store-mixin';
import { mapGetters } from 'vuex';
import formattedCurrencyMixin from '@js/mixins/formatted-currency';
import receiptFeatureFlagMixin from './receipt-feature-flag-mixin';

export default {
    mixins: [
        receiptMixin,
        StoreMixin,
        formattedCurrencyMixin,
        receiptFeatureFlagMixin,
    ],

    computed: {
        ...mapGetters('transactionPostgres', [
            'discountLineItems',
            'multipleDiscountLineItems',
            'products',
            'fuels',
            'cancelProducts',
            'isSale',
            'isRefund',
            'isVoid',
            'groupDiscounts',
        ]),
    },

    methods: {
        discountTotal(discounts) {
            return discounts
                .map(d => {
                    return parseFloat(d.applied_amount);
                })
                .reduce((a, b) => a + b, 0)
                .toFixed(2);
        },

        discountFuelPrice(item) {
            return (item.net_amount / item.quantity).toFixed(3);
        },

        shouldShowDiscount(discountLineItems, itemKey, discount) {
            if (itemKey === 0) {
                let d = discountLineItems[itemKey].applied_discounts.filter(
                    appliedDiscount => {
                        return (
                            discount.discount_id === appliedDiscount.discount_id
                        );
                    },
                );

                if (d.length) {
                    return true;
                }
            }

            return false;
        },

        itemAppliedDiscountPerLineItem(item) {
            if (this.hasReceiptCapillaryOrderLevel) {
                const itemAppliedDiscounts = item.applied_discounts.filter(
                    discount => {
                        return (
                            discount.discount.discount_source !==
                            'SHELL_CAPILLARY'
                        );
                    },
                );

                return {
                    itemAppliedDiscounts,
                    perLineItem: false,
                };
            }

            const itemAppliedDiscounts = item.applied_discounts;

            return {
                itemAppliedDiscounts,
                perLineItem: true,
            };
        },

        groupDiscountPerGroupItem(discount) {
            return !(
                this.hasReceiptCapillaryOrderLevel &&
                discount.discountSource === 'SHELL_CAPILLARY'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.voided {
    font-size: 14px;
    vertical-align: middle;
}
.grand-total-amount {
    border: 1px solid #666;
    border-radius: 5px;
    margin-left: 0;
    margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt-postgres/orders.vue